module.exports = __webpack_public_path__ + "img/advantage5Orange.7e3af6fd.png";